import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import classes from '../growthBySpecializations.module.scss';
import Select from '../../../../_common/Form/Selects/Select/Select';
import Button from '../../../../_common/Form/Buttons/Button';
import { getSelectRepListRequest } from '../../../../../store/actions/users';
import { stateOptions } from '../../../../../utils/data/data';
import accountHelpers from '../../../../../utils/accountHelpers';
import InputField from '../../../../_common/Form/TextFields/InputField';

const limit = 20;

const GrowthBySpecializationsFilters = ({
  setFilterData, filtersData, updateFilters, clearFilters,
}) => {
  const dispatch = useDispatch();
  const { selectRepList, pageCount, currentPage } = useSelector((store) => store.users);

  useEffect(() => {
    dispatch(getSelectRepListRequest({ limit, role: 'Rep' }));
  }, []);

  const nextOptionListRequest = async (page) => {
    await dispatch(getSelectRepListRequest({ page, limit, role: 'Rep' }));
  };

  const changeRequestData = (path, value) => {
    setFilterData((prev) => ({ ...prev, [path]: value }));
  };

  const update = () => {
    updateFilters();
  };

  return (
    <div className={classes.filters_wrapper}>
      {accountHelpers.getUser()?.role !== 'Rep' && (
        <div className={classes.select_wrapper}>
          <Select
            label="All reps"
            nextOptionListRequest={nextOptionListRequest}
            options={selectRepList}
            totalPage={pageCount}
            currentPage={currentPage}
            limit={limit}
            currentOption={filtersData.rep}
            onChange={(option) => changeRequestData('rep', option)}
            optionPathname="name"
          />
        </div>
      )}

      <div className={classes.select_wrapper}>
        <Select
          label="All state"
          options={stateOptions}
          currentOption={filtersData.state}
          onChange={(option) => changeRequestData('state', option)}
        />
      </div>

      <div className={classes.select_wrapper}>
        <InputField
          label="Product"
          onChange={(value) => changeRequestData('product', value)}
          value={filtersData.product}
        />
      </div>

      <div className={classes.btns_wrapper}>
        <Button
          title="Update"
          onClick={update}
        />

        <Button
          title="Clear"
          clearButton
          onClick={clearFilters}
        />
      </div>
    </div>
  );
};

GrowthBySpecializationsFilters.propTypes = {
  filtersData: PropTypes.object.isRequired,
  setFilterData: PropTypes.func.isRequired,
  updateFilters: PropTypes.func.isRequired,
  clearFilters: PropTypes.func.isRequired,
};

export default GrowthBySpecializationsFilters;
